var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: [
        "media-item",
        {
          "media-item--selected": _vm.selected,
          "media-item--allowed": _vm.allowed,
          "media-item--not-moderated": _vm.notModerated,
          "media-item--disabled": _vm.disabled,
        },
      ],
      attrs: { href: _vm.profileMedia.url },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _vm.bulkIsActive && !_vm.disabled
        ? _c(
            "div",
            { staticClass: "media-item__top-left-slot" },
            [_vm.selected ? _c("svg-profile-media-selected") : _vm._e()],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-item__top-right-slot" },
        [
          _vm.allowed ? _c("svg-mcv-verified") : _vm._e(),
          _vm._v(" "),
          _vm.notModerated ? _c("svg-profile-media-not-moderated") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.placeholder
        ? _c(
            "div",
            { staticClass: "media-item__placeholder" },
            [_c("svg-profile-media-placeholder")],
            1
          )
        : _vm.isImage
        ? _c("img", {
            staticClass: "media-item__img",
            attrs: { src: _vm.profileMedia.url },
            on: { error: _vm.handleImageError },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }